import React from 'react';
import { useFormContext } from 'react-hook-form';

import { ChocoSelect } from '../../../../../../../../components/FormComponents';

export type CutoffType = 'no_cutoff' | 'strict' | 'flexible';

const CUTOFF_TYPE_OPTIONS = [
  {
    value: 'no_cutoff',
    label: 'No Cutoff',
    description: "This customer doesn't need to obey cutoff times",
  },
  {
    value: 'strict',
    label: 'Strict',
    description: 'Orders after the cutoff time are not possible',
  },
  {
    value: 'flexible',
    label: 'Flexible',
    description:
      'Orders after the cutoff time are possible. Customers will see a warning that the requested delivery date might not be met.',
  },
];

export const CutoffTypeSelect: React.FC = () => {
  const { watch, setValue } = useFormContext();
  const cutoffType = watch('cutoffType');

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newType = e.target.value as CutoffType;
    setValue('cutoffType', newType, {
      shouldDirty: true,
      shouldValidate: true,
      shouldTouch: true,
    });
  };

  const selectedOption = CUTOFF_TYPE_OPTIONS.find(
    (opt) => opt.value === cutoffType
  );

  return (
    <div className="space-y-2">
      <h4 className="text-sm font-medium text-foreground">Cutoff Type</h4>
      <ChocoSelect
        value={cutoffType}
        onChange={handleChange}
        options={CUTOFF_TYPE_OPTIONS}
        className="max-w-xs"
        aria-label="Select cutoff type"
        label="Select cutoff type"
      />
      {selectedOption && (
        <p className="text-sm text-default-600">{selectedOption.description}</p>
      )}
    </div>
  );
};
